import { CountryOption } from '~/lib/api/me/types';
import { Country } from '~/lib/api/smartsend/types';

export const cCache: { countries: Country[]; countryOptions: CountryOption[] } = {
  countries: [],
  countryOptions: []
};
